// import ConfigManager from "@/config/ConfigManager";
import BzbsProfile from "@/core/Account/service/BzbsProfile";
import { RegisterCardModelBuilder, VerifyCardModelBuilder } from "@/core/Account/model/RegisterCardModel";

export default function useRegisterCardComposable() {

    const apiRegisterCreditCard = (token, returnUrl) => {
        return new Promise((resolve, reject) => {
            let paramsBuilder = new RegisterCardModelBuilder()
            paramsBuilder.setReturnUrl(returnUrl)
            let params = paramsBuilder.create().getParams()

            BzbsProfile.registerCard(token, params).subscribe({
                next: (data) => {
                    resolve(data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    const apiVerifyCreditCard = function (transId) {
        return new Promise((resolve, reject) => {
            let paramsBuilder = new VerifyCardModelBuilder()
            paramsBuilder.setTransactionId(transId)
            let params = paramsBuilder.create().getParams()

            BzbsProfile.verifyCard(params).subscribe({
                next: (data) => {
                    resolve(data)
                },
                error: (err) => {
                    reject(err.error.data)
                }
            })
        })
    }

    const apiCancelMember = function () {
        return new Promise((resolve, reject) => {
            BzbsProfile.cancelMemberCard().subscribe({
                next: (resp) => {
                    resolve(resp)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    return {
        apiRegisterCreditCard,
        apiVerifyCreditCard,
        apiCancelMember
    }
}
